import React from "react";

/**
 * Amber disclaimer shown above the fold: web/api metrics start at rollout,
 * email channel has historical data.
 */
export const InfoBox: React.FC = () => {
  return (
    <div
      className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800"
      data-testid="call-views-info-box"
      role="note"
    >
      <span className="font-medium">Uwaga: </span>
      Dane dla kanałów <strong>web</strong> i <strong>api</strong> zbierane są od
      dnia wdrożenia funkcji. Kanał <strong>email</strong> ma historię wcześniejszą.
    </div>
  );
};

export default InfoBox;
